namespace Matrix.Rebalancer {
    export interface SummaryViewForm {
        ViewCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        ModelTypeCode: FormatLookupEditor;
        OwnershipBasisCode: FormatLookupEditor;
        Columns: SummaryViewColumnGrid;
        Formats: SummaryViewFormatGrid;
        Accounts: SummaryViewAllAccountGrid;
        Instances: SummaryViewInstanceGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SummaryViewForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.SummaryView';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SummaryViewForm.init)  {
                SummaryViewForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = FormatLookupEditor;
                var w2 = SummaryViewColumnGrid;
                var w3 = SummaryViewFormatGrid;
                var w4 = SummaryViewAllAccountGrid;
                var w5 = SummaryViewInstanceGrid;
                var w6 = StaticTextBlock;
                var w7 = ReadOnlyDateTime;

                Q.initFormType(SummaryViewForm, [
                    'ViewCode', w0,
                    'Name', w0,
                    'ModelTypeCode', w1,
                    'OwnershipBasisCode', w1,
                    'Columns', w2,
                    'Formats', w3,
                    'Accounts', w4,
                    'Instances', w5,
                    'CreatedBy', w6,
                    'CreatedWhen', w7,
                    'UpdatedBy', w6,
                    'UpdatedWhen', w7,
                    'Version', w6
                ]);
            }
        }
    }
}
